import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideMenuComponent } from '../../../shared/side-menu/side-menu.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-main-layout',
  imports: [
    CommonModule,
    SideMenuComponent,
    RouterModule
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  isMenuCollapsed = false;

  onMenuCollapsedChange(collapsed: boolean) {
    this.isMenuCollapsed = collapsed;
  }
}
